//mapping for the tab validation. This will be used to map the validation for the tabs to the correct key in the data
export const TAB_VALIDATION_MAPPING = {
  Invalid: 'Invalid',
  addressValid: 'BPaddress',
  contactsValid: 'BPContacts',
  billingDetailsValid: 'BPBillingDetails',
  cabieValid: 'BPCabie',
  companyDetailsValid: 'BPcompanydetails',
  customsAndComplianceValid: 'BPCustomsAndCompliance',
  documentsValid: 'BPDocuments',
  parentsValid: 'BPParents',
};

//mapping for the column names. This will be used to map the column names from the database when doing the get to what we need when updating the data
export const BP_COLUMN_NAMES = {
  'Position in Company': 'companyPosition',
  'Business Phone Number': 'phoneNumber',
  Type: 'businessType',
  'CABIE Status': 'CABIEStatus',
  'Secondary Status': 'secondaryStatus',
  'Company Name': 'companyName',
  'Legal Name of Entity': 'entityLegalName',
  Jurisdiction: 'jurisdiction',
  'Trader EORI Number': 'eoriNumber',
  'VAT Number': 'companyVatNumber',
  'Company Registration Number': 'companyRegNumber',
  'Hubspot Reference': 'hubspotReference',
  'First Name': 'firstName',
  'Last Name': 'lastName',
  Email: 'emailAddress',
  'Building Name/Number': 'building',
  Street: 'street',
  'Town/City': 'city',
  County: 'county',
  Postcode: 'postcode',
  Country: 'country',
  'Payment Contact Name': 'paymentName',
  'Payment Contact Phone Number': 'paymentPhone',
  'Payment Contact Email': 'paymentEmail',
  'Sage Reference': 'sageReference',
  'Last Credit Check': 'lastCreditCheck',
  'Billable Type': 'billableType',
  'Duty Threshold': 'dutyThreshold',
  'Duty Admin Fee': 'dutyAdminFee',
  'Duty Admin Fee Unit': 'dutyAdminFeeUnit',
  'Duty Admin Dropdown': 'dutyAdminDropdown',
  'Billable Charged To In': 'billableChargedToIn',
  'EORI TAN Usage - To be charged in': 'eoriTanUsage',
  'Duty Charged to': 'dutyChargedTo',
  //customs and compliance
  'Billable Customer': 'billableCustomer',
  'Standing Authority': 'sa21',
  'Account Application': 'accountApplication',
  'Terms & Conditions': 'termsAndConditions',
  'Ex Works Authorisation': 'exWorksAuthorisation',
  'Deferment Account': 'defermentNumber',
  'TAN Account': 'defermentNumber', //deferment is called TAN for Ireland EORIs
  'Deferment Authorised': 'defermentAuthorised',
  'TAN Authorised': 'defermentAuthorised', //deferment is called TAN for Ireland EORIs
  'Postponed VAT Accounting': 'postponedVatAccounting',
  CCG: 'CCGheld',
  'CCG Reference': 'CCGReference',
  'Cash Account Number': 'cashAccountNumber',
  'FFD MoP': 'ffdMoP',
  PHILIS: 'philis',
  'Customs Warehouse ID': 'warehouseID',
  'Supervising Office': 'supervisingOffice',
  'Send data to Customaite?': 'sendToCustomaite',
  'Valuation Method': 'valuationMethod',
  'Representation Type': 'representationType',
  Representative: 'representative',
  'Restrict VAT Options': 'vatRestriction',
  'Account Manager': 'accountManager',
  'Allow SA on NeeNors?': 'allowSAOnNeeNors',
  SLA: 'sla',
  'Jira Ticket': 'isJiraTicketRequired',
  'Movement Type': 'movementType',
  'Full Load or Groupage': 'loadType',
  'Country of Despatch': 'countryDespatch',
  'Country of Destination': 'countryDestination',
  'Exit Port': 'exitPort1',
  'Entry Port': 'entryPort1',
  'Port Model': 'portModel',
  'Shipping Status': 'shippingStatus',
  'Trailer No': 'trailerNo',
  Container: 'container',
};

export const BP_STEPPER_TABLES = {
  BPcompanydetails: ['Business Partner', 'Company', 'Main Contact Details'],
  BPaddress: ['Address'],
  BPContacts: ['Contacts'],
  BPCabie: ['Trader Data', 'Trader Settings'],
  BPBillingDetails: ['Company Payment Details', 'Billable Settings'],
  BPCustomsAndCompliance: ['Authorisation Documents', 'Customs Authorisations'],
  BPDocuments: ['Documents'],
  BPParents: ['Parents'],
  BPDefaults: ['Defaults'],
};

export const SECTIONS = {
  BPCompanyDetails: [
    { gridClassName: 'business-partners', title: 'Business Partner' },
    { gridClassName: 'company', title: 'Company' },
    { gridClassName: 'main-contact-details', title: 'Main Contact Details' },
  ],
  'bp-address': [{ gridClassName: 'address', title: 'Address' }],
  'bp-customscompliance': [
    { gridClassName: 'authorisation-documents', title: 'Authorisation Documents' },
    { gridClassName: 'customs-authorisations', title: 'Customs Authorisations' },
  ],
  'bp-cabie': [
    { gridClassName: 'trader-notes', title: 'Trader Notes' },
    { gridClassName: 'trader-data', title: 'Trader Data' },
    { gridClassName: 'trader-settings', title: 'Trader Settings' },
  ],
  'bp-billingdetails': [
    { gridClassName: 'company-payment-details', title: 'Company Payment Details' },
    { gridClassName: 'billable-settings', title: 'Billable Settings' },
  ],
  'bp-defaults': [{ title: 'Defaults' }],
};

// Map our display keys to API expected keys for Billable Settings save
export const BILLABLE_SETTINGS_SAVE_KEYS = {
  dutyThreshold: 'dutyThreshold',
  dutyAdminFee: 'dutyAdminFee',
  dutyAdminFeeUnit: 'dutyAdminDropdown',
  eoriTanUsage: 'eoriTanUsage',
  dutyChargedTo: 'billableChargedToIn',
};

export const fetchDataForBPMenu = async (
  activeStepKey,
  handleFetchBusinessPartnerDropdownValues,
  handleAddData,
  handleFetchDutyAdminDropdown
) => {
  switch (activeStepKey) {
    case 'BPcompanydetails':
      await handleFetchBusinessPartnerDropdownValues('CABIE Status');
      await handleFetchBusinessPartnerDropdownValues('Secondary Status');
      await handleFetchBusinessPartnerDropdownValues('Type');
      await handleAddData('Business Partner', activeStepKey);
      await handleAddData('Company', activeStepKey);
      await handleAddData('Main Contact Details', activeStepKey);
      break;
    case 'BPaddress':
      handleFetchBusinessPartnerDropdownValues('Country');
      handleAddData('Address', 'BPaddress');
      break;
    case 'BPContacts':
      await handleAddData('Contacts', 'BPContacts');
      break;
    case 'BPBillingDetails':
      await handleAddData('Business Partner', 'BPBillingDetails');
      await handleFetchBusinessPartnerDropdownValues('Billable Type');
      if (handleFetchDutyAdminDropdown) {
        await handleFetchDutyAdminDropdown(); // Fetches both charged=0 and charged=1 in one update
      }
      await handleAddData('Company Payment Details', 'BPBillingDetails');
      await handleAddData('Billable Settings', 'BPBillingDetails');
      break;
    case 'BPCabie':
      handleAddData('Trader Notes', activeStepKey, false);
      handleAddData('Trader Data', activeStepKey, false);
      handleAddData('Trader Settings', activeStepKey, false);
      handleFetchBusinessPartnerDropdownValues('Send data to Customaite?');
      handleFetchBusinessPartnerDropdownValues('Valuation Method');
      handleFetchBusinessPartnerDropdownValues('Representation Type');
      handleFetchBusinessPartnerDropdownValues('Representative');
      handleFetchBusinessPartnerDropdownValues('Restrict VAT Options');
      handleFetchBusinessPartnerDropdownValues('SLA');
      break;
    case 'BPCustomsAndCompliance':
      handleFetchBusinessPartnerDropdownValues('Billable Customer');
      handleFetchBusinessPartnerDropdownValues('Standing Authority');
      handleFetchBusinessPartnerDropdownValues('Deferment Authorised');
      handleFetchBusinessPartnerDropdownValues('Postponed VAT Accounting');
      handleFetchBusinessPartnerDropdownValues('CCG');
      handleFetchBusinessPartnerDropdownValues('FFD MoP');
      //if activeStepkey is the current step we are in, then load the data into the context
      handleAddData('Authorisation Documents');
      handleAddData('Customs Authorisations');
      break;
    case 'BPParents':
      handleAddData('Parents', activeStepKey);
      break;
    case 'BPDefaults':
      handleAddData('Defaults');
      break;

    default:
      break;
  }
};
